import http from "./httpService";

const apiEndpoint = "/client/bonus";

export function getBonuses(params = {}) {
  return http.get(apiEndpoint, { params });
}

export function getBonus(id) {
  return http.get(`${apiEndpoint}/${id}`);
}
